import { Grid, Typography } from '@mui/material';
import Error500 from '../../../icons/505Error.svg';
import BadRequestIcon from '../../../icons/Badrequesterror.svg';
import React from 'react';
import { ErrorType } from '../../../app/store';

interface ledgerErrorBodyProps extends ErrorType {}

export default function LedgerErrorBody({ statusCode, message }: ledgerErrorBodyProps) {
  return (
    <React.Fragment>
      <Grid container direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ height: '100vh' }}>
        <Grid item display="flex" flexDirection="column" alignItems="center">
          <Grid item display="flex" justifyContent="center" sx={{ marginLeft: '5%' }}>
            <img src={String(statusCode)[0] === '4' ? BadRequestIcon : Error500} alt="error" style={{ height: '35vh' }} />
          </Grid>
          <Grid item justifyContent="center" mt={2} xs={8}>
            <Typography id="ledger-error-heading">{message?.length === 0 ? 'Apologies, something went wrong while fetching ledger details.' : message}</Typography>
          </Grid>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
